import angular from 'angular';

export class SidebarService {
  static $inject = [];

  isShown = false;

  init() {}

  toggle() {
    if (this.isShown) {
      return this.hide();
    }

    return this.show();
  }

  hide() {
    this.isShown = false;
    $('.main').removeClass('no-scroll');

    return this.isShown;
  }

  show() {
    this.isShown = true;
    $('.main').addClass('no-scroll');

    return this.isShown;
  }
}

export const SidebarServiceModule = angular
  .module('acme.common.service.sidebar', [])
  .service('SidebarService', SidebarService).name;
